function configureExperianTile(brand, tile = {}) {
    if (!tile.link || !tile.link.href) {
        return tile;
    }

    const updatedHref = tile.tileType === 'EXPERIAN_APPENDED' ? `${tile.link.href}&brand=${brand}` : tile.link.href;

    return {
        ...tile,
        link: {
            ...tile.link,
            href: updatedHref,
        },
    };
}

export default configureExperianTile;
